var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#4D008C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.107 22.774c.309-.31.81-.31 1.12 0L42.892 35.44c.31.31.31.81 0 1.12L30.227 49.226a.792.792 0 01-1.12-1.12L41.214 36 29.107 23.893a.791.791 0 010-1.12z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIHZpZXdCb3g9IjAgMCA3MiA3MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjcyIiBoZWlnaHQ9IjcyIiByeD0iMzYiIGZpbGw9IiM0RDAwOEMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOS4xMDY5IDIyLjc3MzZDMjkuNDE2IDIyLjQ2NDQgMjkuOTE3MyAyMi40NjQ0IDMwLjIyNjUgMjIuNzczNkw0Mi44OTMxIDM1LjQ0MDJDNDMuMjAyMyAzNS43NDk0IDQzLjIwMjMgMzYuMjUwNiA0Mi44OTMxIDM2LjU1OThMMzAuMjI2NSA0OS4yMjY1QzI5LjkxNzMgNDkuNTM1NiAyOS40MTYgNDkuNTM1NiAyOS4xMDY5IDQ5LjIyNjVDMjguNzk3NyA0OC45MTczIDI4Ljc5NzcgNDguNDE2MSAyOS4xMDY5IDQ4LjEwNjlMNDEuMjEzNyAzNkwyOS4xMDY5IDIzLjg5MzFDMjguNzk3NyAyMy41ODQgMjguNzk3NyAyMy4wODI3IDI5LjEwNjkgMjIuNzczNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgChevronIcon as ReactComponent };